import { createContext, useCallback, useEffect, useState } from "react";

export const AuthContext = createContext({
  user: null,
  isLoggedIn: false,
  getUser: () => {},
  setUser: (user: null | any) => {},
});

const AuthContextProvider = ({ children }: { children: JSX.Element }) => {
  const [user, _setUser] = useState<any>(null);

  const loadUserFromStorage = useCallback(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser !== null) {
      _setUser(JSON.parse(storedUser));
    }
  }, []);

  const setUser = useCallback((_user) => {
    _setUser(_user);
    if (_user === null) {
      localStorage.removeItem("user");
    } else {
      localStorage.setItem("user", JSON.stringify(_user));
    }
  }, []);

  useEffect(() => {
    loadUserFromStorage();
  }, []);

  return (
    <AuthContext.Provider value={{ isLoggedIn: !!user, user, setUser, getUser: () => user }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;
